/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Drop_FrameInputs */

const en_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Drop Frame`)
};

const fr_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop frame source`)
};

const de_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle Drop Frame`)
};

const it_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Origine Drop Frame`)
};

const ru_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходный кадр`)
};

const es_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotograma a eliminar de origen`)
};

const zh_cn2_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源丢帧`)
};

const ja_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースドロップフレーム`)
};

const hi_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत ड्रॉप फ्रेम`)
};

const pt_pt2_source_drop_frame = /** @type {(inputs: Source_Drop_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadro de origem`)
};

/**
* | output |
* | --- |
* | "Source Drop Frame" |
*
* @param {Source_Drop_FrameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_drop_frame = /** @type {((inputs?: Source_Drop_FrameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Drop_FrameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_source_drop_frame(inputs)
	if (locale === "de") return de_source_drop_frame(inputs)
	if (locale === "it") return it_source_drop_frame(inputs)
	if (locale === "ru") return ru_source_drop_frame(inputs)
	if (locale === "es") return es_source_drop_frame(inputs)
	if (locale === "zh-CN") return zh_cn2_source_drop_frame(inputs)
	if (locale === "ja") return ja_source_drop_frame(inputs)
	if (locale === "hi") return hi_source_drop_frame(inputs)
	if (locale === "pt-PT") return pt_pt2_source_drop_frame(inputs)
	return en_source_drop_frame(inputs)
});